import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setPreSchedulingList: [],
    setLoadingPreSchedulingList: [],
    setPreSchedulingDetails: [],
    setTimeZoneList: [],
    setWorkHourTypeList: [],
    cleanPreSchedulingDetails: [],
    setPreSchedulingLoading: [],
    setPreSchedulingToast: [],
    setSelectedPreScheduling: [],
    unsetSelectedPreScheduling: [],
    setUpdatePreSchedulingForm: [],
    setGetPreSchedulingLoading: [],
    setFetchedPreSchedulingDetails: [],
    setGetPreScheduling: [],
    setLoadingPreSchedulingReport: [],
	setCsvPreSchedulingReport: []
});
 
/**
 * Handlers
 */
const INITIAL_STATE = {
    preSchedulingList: [],
    isLoadingPreSchedulingList: false,
    preSchedulingDetails: {},
    fetchedPreSchedulingDetails: {},
    timeZoneList: [],
    workHourTypeList: [],
    preSchedulingLoading: false,
    preSchedulingToast: {
        showToast: false,
        message: '',
        messageType: 'toast-success'
    },
    selectedPreScheduling: {
        id: null,
        data: {}
    },
    updateForm: false,
    getPreSchedulingLoading: false,
    getPreScheduling: null,
    isLoadingPreSchedulingReport: false,
	csvReportData: []
};
 
const setPreSchedulingList = (state = INITIAL_STATE, action) => {
    return { ...state, preSchedulingList: action.payload };
}

const setLoadingPreSchedulingList = (state = INITIAL_STATE, action) => {
    return { ...state, isLoadingPreSchedulingList: action.payload };
}

const setPreSchedulingDetails = (state = INITIAL_STATE, action) => {
    return { ...state, preSchedulingDetails: action.payload };
}

const setTimeZoneList = (state = INITIAL_STATE, action) => {
    return { ...state, timeZoneList: action.payload };
}

const setWorkHourTypeList = (state = INITIAL_STATE, action) => {
    return { ...state, workHourTypeList: action.payload };
}

const cleanPreSchedulingDetails = (state = INITIAL_STATE, action) => {
    return { ...state, preSchedulingDetails: {} };
}

const setPreSchedulingLoading = (state = INITIAL_STATE, action) => {
    return { ...state, preSchedulingLoading: action.payload };
}

const setPreSchedulingToast = (state = INITIAL_STATE, action) => {
    return {
        ...state, 
        preSchedulingToast: {
            showToast: action.payload.showToast,
            message: action.payload.message,
            messageType: action.payload.messageType
        }
    };
}

const setSelectedPreScheduling = (state = INITIAL_STATE, action) => {
    return { ...state, selectedPreScheduling: action.payload };
}

const unsetSelectedPreScheduling = (state = INITIAL_STATE, action) => {
    return { ...state, selectedPreScheduling: action.payload };
}

const setUpdatePreSchedulingForm = (state = INITIAL_STATE, action) => {
    return { ...state, updateForm: action.payload };
}

const setGetPreSchedulingLoading = (state = INITIAL_STATE, action) => {
    return { ...state, getPreSchedulingLoading: action.payload };
}

const setFetchedPreSchedulingDetails = (state = INITIAL_STATE, action) => {
    return { ...state, fetchedPreSchedulingDetails: action.payload };
}

const setGetPreScheduling = (state = INITIAL_STATE, action) => {
    return { ...state, getPreScheduling: action.payload };
}

const setLoadingPreSchedulingReport = (state = INITIAL_STATE, action) => {
	return {...state, isLoadingPreSchedulingReport: action.payload }
}

const setCsvPreSchedulingReport = (state = INITIAL_STATE, action) => {
	return {...state, csvReportData: action.payload }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {   
    [Types.SET_PRE_SCHEDULING_LIST]: setPreSchedulingList,
    [Types.SET_LOADING_PRE_SCHEDULING_LIST]: setLoadingPreSchedulingList,
    [Types.SET_PRE_SCHEDULING_DETAILS]: setPreSchedulingDetails,
    [Types.SET_TIME_ZONE_LIST]: setTimeZoneList,
    [Types.SET_WORK_HOUR_TYPE_LIST]: setWorkHourTypeList,
    [Types.CLEAN_PRE_SCHEDULING_DETAILS]: cleanPreSchedulingDetails,
    [Types.SET_PRE_SCHEDULING_LOADING]: setPreSchedulingLoading,
    [Types.SET_PRE_SCHEDULING_TOAST]: setPreSchedulingToast,
    [Types.SET_SELECTED_PRE_SCHEDULING]: setSelectedPreScheduling,
    [Types.UNSET_SELECTED_PRE_SCHEDULING]: unsetSelectedPreScheduling,
    [Types.SET_UPDATE_PRE_SCHEDULING_FORM]: setUpdatePreSchedulingForm,
    [Types.SET_GET_PRE_SCHEDULING_LOADING]: setGetPreSchedulingLoading,    
    [Types.SET_FETCHED_PRE_SCHEDULING_DETAILS]: setFetchedPreSchedulingDetails,
    [Types.SET_GET_PRE_SCHEDULING]: setGetPreScheduling,
    [Types.SET_LOADING_PRE_SCHEDULING_REPORT] : setLoadingPreSchedulingReport,
	[Types.SET_CSV_PRE_SCHEDULING_REPORT] : setCsvPreSchedulingReport,
});
 